var equality = {
    EQUALS: 'Equals',
    STARTS_WITH: 'StartsWith',
    CONTAINS: 'Contains'
}

export {
    equality
}



// WEBPACK FOOTER //
// ./web-app/constants/search-constants.js